import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  margin: 0 10px;\n  ', '\n'], ['\n  margin: 0 10px;\n  ', '\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  margin: 20px auto 10px;\n'], ['\n  margin: 20px auto 10px;\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject, function (_ref) {
  var isAddOnModal = _ref.isAddOnModal;
  return isAddOnModal && 'flex-basis: 48%;';
});

export var StyledButtonWrapper = styled.div(_templateObject2);